export default __webpack_public_path__ + "static/prezydent_gdansk-79c7880fbfdccd41f20b862a742837d9.jpg";